import axios from "axios";

export function signIn(username, password) {
    return {
        type: "SIGN_IN",
        payload: axios.post("/rest/authentication/sign-in", {
            username,
            password
        })
    }
}

export function signInByToken(token) {
    return {
        type: "SIGN_IN_BY_TOKEN",
        payload: axios.post("/rest/authentication/sign-in/" + token)
    }
}

export function updateEmail(value) {
    return {
        type: "SIGN_IN_UPDATE_EMAIL",
        value
    }
}

export function updatePassword(value) {
    return {
        type: "SIGN_IN_UPDATE_PASSWORD",
        value
    }
}


// WEBPACK FOOTER //
// ./src/actions/signIn.js